import { useOperatorCompactRoute } from '@/utils/operatorCompact.js';

export default function PageHeader({ title, subtitle, actions, forceVisible = false }) {
  const { isOperatorCompact } = useOperatorCompactRoute();
  const hideTitleBlock = isOperatorCompact && !forceVisible;

  if (hideTitleBlock && !actions) {
    return null;
  }

  return (
    <header className={hideTitleBlock ? 'mb-1' : 'mb-3'}>
      <div className={`flex ${hideTitleBlock ? 'justify-end' : 'flex-col gap-2 lg:flex-row lg:items-start lg:justify-between'}`}>
        {!hideTitleBlock ? (
        <div>
          <h1 className="text-lg font-semibold text-[rgb(var(--fg))] lg:text-[1.35rem]">{title}</h1>
          {subtitle ? <p className="mt-0.5 text-sm text-muted">{subtitle}</p> : null}
        </div>
        ) : null}
        <div className="flex flex-wrap items-center gap-1.5 lg:justify-end">{actions}</div>
      </div>
    </header>
  );
}
